webpackJsonp([2345137460201621000],{

/***/ "./node_modules/process/browser.js":
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/react-burger-menu/lib/BurgerIcon.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var BurgerIcon = (function (_Component) {
	  _inherits(BurgerIcon, _Component);
	
	  function BurgerIcon(props) {
	    _classCallCheck(this, BurgerIcon);
	
	    _get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      hover: false
	    };
	  }
	
	  _createClass(BurgerIcon, [{
	    key: 'getLineStyle',
	    value: function getLineStyle(index) {
	      return {
	        position: 'absolute',
	        height: '20%',
	        left: 0,
	        right: 0,
	        top: 20 * (index * 2) + '%',
	        opacity: this.state.hover ? 0.6 : 1
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon = undefined;
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        opacity: 0,
	        fontSize: 8
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-icon',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmIcon)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          null,
	          [0, 1, 2].map(function (bar) {
	            return _react2['default'].createElement('span', {
	              key: bar,
	              className: 'bm-burger-bars ' + _this.props.barClassName,
	              style: _extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: 'bm-burger-button ' + this.props.className,
	          style: _extends({ zIndex: 1 }, this.props.styles.bmBurgerButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          {
	            onClick: this.props.onClick,
	            onMouseOver: function () {
	              return _this.setState({ hover: true });
	            },
	            onMouseOut: function () {
	              return _this.setState({ hover: false });
	            },
	            style: buttonStyle
	          },
	          'Open Menu'
	        )
	      );
	    }
	  }]);
	
	  return BurgerIcon;
	})(_react.Component);
	
	exports['default'] = BurgerIcon;
	
	BurgerIcon.propTypes = {
	  barClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	BurgerIcon.defaultProps = {
	  barClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-burger-menu/lib/CrossIcon.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var CrossIcon = (function (_Component) {
	  _inherits(CrossIcon, _Component);
	
	  function CrossIcon() {
	    _classCallCheck(this, CrossIcon);
	
	    _get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CrossIcon, [{
	    key: 'getCrossStyle',
	    value: function getCrossStyle(type) {
	      return {
	        position: 'absolute',
	        width: 3,
	        height: 14,
	        transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon;
	      var buttonWrapperStyle = {
	        position: 'absolute',
	        width: 24,
	        height: 24,
	        right: 8,
	        top: 8
	      };
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        textIndent: -9999,
	        background: 'transparent',
	        outline: 'none'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-cross',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmCross)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          { style: { position: 'absolute', top: '6px', right: '14px' } },
	          ['before', 'after'].map(function (type, i) {
	            return _react2['default'].createElement('span', {
	              key: i,
	              className: 'bm-cross ' + _this.props.crossClassName,
	              style: _extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: 'bm-cross-button ' + this.props.className,
	          style: _extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          { onClick: this.props.onClick, style: buttonStyle },
	          'Close Menu'
	        )
	      );
	    }
	  }]);
	
	  return CrossIcon;
	})(_react.Component);
	
	exports['default'] = CrossIcon;
	
	CrossIcon.propTypes = {
	  crossClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	CrossIcon.defaultProps = {
	  crossClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-burger-menu/lib/baseStyles.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var styles = {
	
	  overlay: function overlay(isOpen) {
	    return {
	      position: 'fixed',
	      zIndex: 1,
	      width: '100%',
	      height: '100%',
	      background: 'rgba(0, 0, 0, 0.3)',
	      opacity: isOpen ? 1 : 0,
	      MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      zIndex: 2,
	      width: width,
	      height: '100%',
	      MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  menu: function menu() {
	    return {
	      height: '100%',
	      boxSizing: 'border-box',
	      overflow: 'auto'
	    };
	  },
	
	  itemList: function itemList() {
	    return {
	      height: '100%'
	    };
	  },
	
	  item: function item() {
	    return {
	      display: 'block',
	      outline: 'none'
	    };
	  }
	
	};
	
	exports['default'] = styles;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-burger-menu/lib/menuFactory.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _baseStyles = __webpack_require__("./node_modules/react-burger-menu/lib/baseStyles.js");
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _BurgerIcon = __webpack_require__("./node_modules/react-burger-menu/lib/BurgerIcon.js");
	
	var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);
	
	var _CrossIcon = __webpack_require__("./node_modules/react-burger-menu/lib/CrossIcon.js");
	
	var _CrossIcon2 = _interopRequireDefault(_CrossIcon);
	
	exports['default'] = function (styles) {
	  var Menu = (function (_Component) {
	    _inherits(Menu, _Component);
	
	    function Menu(props) {
	      _classCallCheck(this, Menu);
	
	      _get(Object.getPrototypeOf(Menu.prototype), 'constructor', this).call(this, props);
	      this.state = {
	        isOpen: props && typeof props.isOpen !== 'undefined' ? props.isOpen : false
	      };
	    }
	
	    _createClass(Menu, [{
	      key: 'toggleMenu',
	      value: function toggleMenu() {
	        var _this = this;
	
	        var newState = { isOpen: !this.state.isOpen };
	
	        this.applyWrapperStyles();
	
	        this.setState(newState, function () {
	          _this.props.onStateChange(newState);
	
	          // Timeout ensures wrappers are cleared after animation finishes.
	          _this.timeoutId && clearTimeout(_this.timeoutId);
	          _this.timeoutId = setTimeout(function () {
	            _this.timeoutId = null;
	            if (!newState.isOpen) {
	              _this.applyWrapperStyles(false);
	            }
	          }, 500);
	        });
	      }
	
	      // Applies component-specific styles to external wrapper elements.
	    }, {
	      key: 'applyWrapperStyles',
	      value: function applyWrapperStyles() {
	        var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	        if (this.props.bodyClassName) {
	          var body = document.querySelector('body');
	          body.classList[set ? 'add' : 'remove'](this.props.bodyClassName);
	        }
	
	        if (styles.pageWrap && this.props.pageWrapId) {
	          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, set);
	        }
	
	        if (styles.outerContainer && this.props.outerContainerId) {
	          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, set);
	        }
	      }
	
	      // Sets or unsets styles on DOM elements outside the menu component.
	      // This is necessary for correct page interaction with some of the menus.
	      // Throws and returns if the required external elements don't exist,
	      // which means any external page animations won't be applied.
	    }, {
	      key: 'handleExternalWrapper',
	      value: function handleExternalWrapper(id, wrapperStyles, set) {
	        var html = document.querySelector('html');
	        var body = document.querySelector('body');
	        var wrapper = document.getElementById(id);
	
	        if (!wrapper) {
	          console.error("Element with ID '" + id + "' not found");
	          return;
	        }
	
	        var builtStyles = this.getStyle(wrapperStyles);
	
	        for (var prop in builtStyles) {
	          if (builtStyles.hasOwnProperty(prop)) {
	            wrapper.style[prop] = set ? builtStyles[prop] : '';
	          }
	        }
	
	        // Prevent any horizontal scroll.
	        [html, body].forEach(function (element) {
	          element.style['overflow-x'] = set ? 'hidden' : '';
	        });
	      }
	
	      // Builds styles incrementally for a given element.
	    }, {
	      key: 'getStyles',
	      value: function getStyles(el, index, inline) {
	        var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());
	
	        // Set base styles.
	        var output = _baseStyles2['default'][el] ? this.getStyle(_baseStyles2['default'][el]) : {};
	
	        // Add animation-specific styles.
	        if (styles[el]) {
	          output = _extends({}, output, this.getStyle(styles[el], index + 1));
	        }
	
	        // Add custom styles.
	        if (this.props.styles[propName]) {
	          output = _extends({}, output, this.props.styles[propName]);
	        }
	
	        // Add element inline styles.
	        if (inline) {
	          output = _extends({}, output, inline);
	        }
	
	        return output;
	      }
	    }, {
	      key: 'getStyle',
	      value: function getStyle(style, index) {
	        var width = this.props.width;
	        if (typeof width !== 'string') width = width + 'px';
	
	        return style(this.state.isOpen, width, this.props.right, index);
	      }
	    }, {
	      key: 'listenForClose',
	      value: function listenForClose(e) {
	        e = e || window.event;
	
	        if (this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        if (!styles) {
	          throw new Error('No styles supplied');
	        }
	
	        // Allow initial open state to be set by props.
	        if (this.props.isOpen) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        window.onkeydown = this.listenForClose.bind(this);
	
	        // Allow initial open state to be set by props for animations with wrapper elements.
	        if (this.props.isOpen) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.onkeydown = null;
	
	        this.applyWrapperStyles(false);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        var _this2 = this;
	
	        if (styles.svg) {
	          (function () {
	            var morphShape = _reactDom2['default'].findDOMNode(_this2, 'bm-morph-shape');
	            var path = styles.svg.lib(morphShape).select('path');
	
	            if (_this2.state.isOpen) {
	              // Animate SVG path.
	              styles.svg.animate(path);
	            } else {
	              // Reset path (timeout ensures animation happens off screen).
	              setTimeout(function () {
	                path.attr('d', styles.svg.pathInitial);
	              }, 300);
	            }
	          })();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (typeof nextProps.isOpen !== 'undefined' && nextProps.isOpen !== this.state.isOpen) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        return _react2['default'].createElement(
	          'div',
	          null,
	          !this.props.noOverlay && _react2['default'].createElement('div', {
	            className: 'bm-overlay ' + this.props.overlayClassName,
	            onClick: function () {
	              return _this3.toggleMenu();
	            },
	            style: this.getStyles('overlay')
	          }),
	          _react2['default'].createElement(
	            'div',
	            {
	              id: this.props.id,
	              className: 'bm-menu-wrap ' + this.props.className,
	              style: this.getStyles('menuWrap')
	            },
	            styles.svg && _react2['default'].createElement(
	              'div',
	              { className: 'bm-morph-shape ' + this.props.morphShapeClassName, style: this.getStyles('morphShape') },
	              _react2['default'].createElement(
	                'svg',
	                { width: '100%', height: '100%', viewBox: '0 0 100 800', preserveAspectRatio: 'none' },
	                _react2['default'].createElement('path', { d: styles.svg.pathInitial })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'bm-menu ' + this.props.menuClassName, style: this.getStyles('menu') },
	              _react2['default'].createElement(
	                'nav',
	                { className: 'bm-item-list ' + this.props.itemListClassName, style: this.getStyles('itemList') },
	                _react2['default'].Children.map(this.props.children, function (item, index) {
	                  if (item) {
	                    var extraProps = {
	                      key: index,
	                      style: _this3.getStyles('item', index, item.props.style)
	                    };
	                    return _react2['default'].cloneElement(item, extraProps);
	                  }
	                })
	              )
	            ),
	            this.props.customCrossIcon !== false && _react2['default'].createElement(
	              'div',
	              { style: this.getStyles('closeButton') },
	              _react2['default'].createElement(_CrossIcon2['default'], {
	                onClick: function () {
	                  return _this3.toggleMenu();
	                },
	                styles: this.props.styles,
	                customIcon: this.props.customCrossIcon,
	                className: this.props.crossButtonClassName,
	                crossClassName: this.props.crossClassName
	              })
	            )
	          ),
	          this.props.customBurgerIcon !== false && _react2['default'].createElement(_BurgerIcon2['default'], {
	            onClick: function () {
	              return _this3.toggleMenu();
	            },
	            styles: this.props.styles,
	            customIcon: this.props.customBurgerIcon,
	            className: this.props.burgerButtonClassName,
	            barClassName: this.props.burgerBarClassName
	          })
	        );
	      }
	    }]);
	
	    return Menu;
	  })(_react.Component);
	
	  Menu.propTypes = {
	    bodyClassName: _propTypes2['default'].string,
	    burgerBarClassName: _propTypes2['default'].string,
	    burgerButtonClassName: _propTypes2['default'].string,
	    crossButtonClassName: _propTypes2['default'].string,
	    crossClassName: _propTypes2['default'].string,
	    customBurgerIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    customCrossIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    id: _propTypes2['default'].string,
	    isOpen: _propTypes2['default'].bool,
	    itemListClassName: _propTypes2['default'].string,
	    menuClassName: _propTypes2['default'].string,
	    morphShapeClassName: _propTypes2['default'].string,
	    noOverlay: _propTypes2['default'].bool,
	    onStateChange: _propTypes2['default'].func,
	    outerContainerId: styles && styles.outerContainer ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    overlayClassName: _propTypes2['default'].string,
	    pageWrapId: styles && styles.pageWrap ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    right: _propTypes2['default'].bool,
	    styles: _propTypes2['default'].object,
	    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	  };
	
	  Menu.defaultProps = {
	    bodyClassName: '',
	    burgerBarClassName: '',
	    burgerButtonClassName: '',
	    className: '',
	    crossButtonClassName: '',
	    crossClassName: '',
	    id: '',
	    itemListClassName: '',
	    menuClassName: '',
	    morphShapeClassName: '',
	    noOverlay: false,
	    onStateChange: function onStateChange() {},
	    outerContainerId: '',
	    overlayClassName: '',
	    pageWrapId: '',
	    styles: {},
	    width: 300
	  };
	
	  return Menu;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-burger-menu/lib/menus/slide.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__("./node_modules/react-burger-menu/lib/menuFactory.js");
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-scrollchor/lib/scrollchor.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__("./node_modules/react-scrollchor/lib/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scrollchor = function (_React$Component) {
	  _inherits(Scrollchor, _React$Component);
	
	  function Scrollchor(props) {
	    _classCallCheck(this, Scrollchor);
	
	    var _this = _possibleConstructorReturn(this, (Scrollchor.__proto__ || Object.getPrototypeOf(Scrollchor)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this._setup(props);
	    _this.simulateClick = _this._handleClick;
	    return _this;
	  }
	
	  _createClass(Scrollchor, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      this._setup(props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          to = _props.to,
	          animate = _props.animate,
	          beforeAnimate = _props.beforeAnimate,
	          afterAnimate = _props.afterAnimate,
	          props = _objectWithoutProperties(_props, ["to", "animate", "beforeAnimate", "afterAnimate"]); // eslint-disable-line no-unused-vars
	
	      return !this.props.children ? null : _react2.default.createElement("a", _extends({}, props, { href: "#" + this._to, onClick: this._handleClick }));
	    }
	  }]);
	
	  return Scrollchor;
	}(_react2.default.Component);
	
	// Default easing function
	// jQuery easing 'swing'
	
	
	Scrollchor.propTypes = {
	  to: _propTypes2.default.string.isRequired,
	  animate: _propTypes2.default.shape({
	    offset: _propTypes2.default.number,
	    duration: _propTypes2.default.number,
	    easing: _propTypes2.default.func
	  }),
	  beforeAnimate: _propTypes2.default.func,
	  afterAnimate: _propTypes2.default.func
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setup = function (props) {
	    _this2._to = props.to && props.to.replace(/^#/, "") || "";
	
	    var _ref = props.animate || {},
	        _ref$offset = _ref.offset,
	        offset = _ref$offset === undefined ? 0 : _ref$offset,
	        _ref$duration = _ref.duration,
	        duration = _ref$duration === undefined ? 400 : _ref$duration,
	        _ref$easing = _ref.easing,
	        easing = _ref$easing === undefined ? easeOutQuad : _ref$easing;
	
	    _this2._animate = { offset: offset, duration: duration, easing: easing };
	    _this2._beforeAnimate = props.beforeAnimate || function () {};
	    _this2._afterAnimate = props.afterAnimate || function () {};
	  };
	
	  this._handleClick = function (event) {
	    _this2._beforeAnimate(event);
	    event && event.preventDefault();
	    (0, _utils.animateScroll)(_this2._to, _this2._animate);
	    _this2._afterAnimate(event);
	  };
	};
	
	exports.default = Scrollchor;
	function easeOutQuad(x, t, b, c, d) {
	  return -c * (t /= d) * (t - 2) + b;
	}

/***/ }),

/***/ "./node_modules/react-scrollchor/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animateScroll = animateScroll;
	
	var _warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function animateScroll(id, animate) {
	  var element = id ? document.getElementById(id) : document.body;
	  (0, _warning2.default)(element, "Cannot find element: #" + id);
	
	  var offset = animate.offset,
	      duration = animate.duration,
	      easing = animate.easing;
	
	  var start = getScrollTop();
	  var to = getOffsetTop(element) + offset;
	  var change = to - start;
	
	  function animateFn() {
	    var elapsedTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    var increment = 20;
	    var elapsed = elapsedTime + increment;
	    var position = easing(null, elapsed, start, change, duration);
	    setScrollTop(position);
	    elapsed < duration && setTimeout(function () {
	      return animateFn(elapsed);
	    }, increment);
	  }
	
	  animateFn();
	  window.location.hash = id;
	}
	
	function getScrollTop() {
	  // like jQuery -> $('html, body').scrollTop
	  return document.documentElement.scrollTop || document.body.scrollTop;
	}
	
	function setScrollTop(position) {
	  document.documentElement.scrollTop = document.body.scrollTop = position;
	}
	
	function getOffsetTop(element) {
	  var _element$getBoundingC = element.getBoundingClientRect(),
	      top = _element$getBoundingC.top;
	
	  return top + getScrollTop();
	}

/***/ }),

/***/ "./node_modules/react-sticky-header/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _Object$getPrototypeOf = _interopDefault(__webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js"));
	var _classCallCheck = _interopDefault(__webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js"));
	var _createClass = _interopDefault(__webpack_require__("./node_modules/babel-runtime/helpers/createClass.js"));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js"));
	var _inherits = _interopDefault(__webpack_require__("./node_modules/babel-runtime/helpers/inherits.js"));
	var React = __webpack_require__("./node_modules/react/react.js");
	var React__default = _interopDefault(React);
	
	function addEvent(event, cb) {
	  window.addEventListener(event, cb, false);
	  return function () {
	    return window.removeEventListener(event, cb, false);
	  };
	}
	
	var _class;
	var _temp2;
	var noop = function noop() {};
	
	var ReactStickyHeader = (_temp2 = _class = function (_Component) {
	  _inherits(ReactStickyHeader, _Component);
	
	  function ReactStickyHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactStickyHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactStickyHeader.__proto__ || _Object$getPrototypeOf(ReactStickyHeader)).call.apply(_ref, [this].concat(args))), _this), _this._detatch = noop, _this._rafExecuting = false, _this.state = {
	      isSticky: _this.props.headerOnly
	    }, _this.calculateStickyState = function () {
	      if (_this._rafExecuting) {
	        return;
	      }
	
	      _this._rafExecuting = true;
	
	      requestAnimationFrame(function () {
	        var stickyHeaderHeight = _this._fixed.offsetHeight;
	        var headerContainer = _this._root.offsetHeight;
	        var headerContainerBoundingBox = _this._root.getBoundingClientRect();
	        var pastStickyThreshold = headerContainer + headerContainerBoundingBox.top - stickyHeaderHeight <= 0;
	
	        if (pastStickyThreshold && !_this.state.isSticky) {
	          _this.setState({
	            isSticky: true
	          });
	
	          _this.props.onSticky(true);
	        } else if (!pastStickyThreshold && _this.state.isSticky) {
	          _this.setState({
	            isSticky: false
	          });
	
	          _this.props.onSticky(false);
	        }
	
	        _this._rafExecuting = false;
	      });
	    }, _this.onResize = function () {
	      // We want to flush a re-render incase the children have changed size from CSS.
	      _this.setState({});
	
	      // We want to check if because of a resize the header is now sticky or not.
	      _this.calculateStickyState();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  // eslint-disable-next-line react/sort-comp
	
	
	  _createClass(ReactStickyHeader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initialise();
	      // Force state change as we need to calculate the header background containers.
	      // eslint-disable-next-line react/no-did-mount-set-state
	      this.setState({});
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._detatch();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.headerOnly !== this.props.headerOnly) {
	        this.calculateStickyState();
	      }
	    }
	  }, {
	    key: 'initialise',
	    value: function initialise() {
	      var _this2 = this;
	
	      if (this._initialised) {
	        return;
	      }
	
	      var detatchScroll = addEvent('scroll', this.calculateStickyState);
	      var detatchResize = addEvent('resize', this.onResize);
	
	      this._detatch = function () {
	        [detatchScroll, detatchResize].forEach(function (detatch) {
	          return detatch();
	        });
	        _this2._initialised = false;
	      };
	
	      this.calculateStickyState();
	      this._initialised = true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var backgroundUrl = this.props.backgroundImage && 'url(\'' + this.props.backgroundImage + '\')';
	      var headerClassName = 'ReactStickyHeader_root' + (this.props.className ? ' ' + this.props.className : '');
	      var rootClassName = '' + headerClassName + (this.state.isSticky ? ' is-sticky' : '');
	      var headerContainerHeight = this._root && this._root.offsetHeight;
	      var fixedHeaderHeight = this._fixed && this._fixed.offsetHeight;
	
	      return React__default.createElement(
	        'header',
	        { className: rootClassName, ref: function ref(e) {
	            return _this3._root = e;
	          } },
	        React__default.createElement(
	          'div',
	          { className: 'ReactStickyHeader_fixed', ref: function ref(e) {
	              return _this3._fixed = e;
	            } },
	          this.props.header
	        ),
	        React__default.createElement('div', {
	          className: 'ReactStickyHeader_midground',
	          style: {
	            height: headerContainerHeight || fixedHeaderHeight,
	            top: fixedHeaderHeight,
	            backgroundImage: backgroundUrl,
	            backgroundColor: this.props.backgroundColor
	          }
	        }),
	        this.props.headerOnly && React__default.createElement('div', { style: { height: fixedHeaderHeight } }),
	        this.props.headerOnly || React__default.createElement('div', {
	          className: 'ReactStickyHeader_background-bg',
	          style: { backgroundImage: backgroundUrl, backgroundColor: this.props.backgroundColor }
	        }),
	        this.props.headerOnly || React__default.createElement('div', {
	          className: 'ReactStickyHeader_foreground',
	          style: { opacity: this.state.isSticky ? 0 : 1, backgroundImage: backgroundUrl, backgroundColor: this.props.backgroundColor }
	        }),
	        this.props.headerOnly || this.props.children
	      );
	    }
	  }]);
	
	  return ReactStickyHeader;
	}(React.Component), _class.defaultProps = {
	  onSticky: noop,
	  headerOnly: false
	}, _temp2);
	
	module.exports = ReactStickyHeader;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/react-sticky-header/styles.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/assets/images/logo.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.a47fddf7.png";

/***/ }),

/***/ "./src/components/burger-menu.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _slide = __webpack_require__("./node_modules/react-burger-menu/lib/menus/slide.js");
	
	var _slide2 = _interopRequireDefault(_slide);
	
	var _headerNav = __webpack_require__("./src/components/header-nav.js");
	
	var _headerNav2 = _interopRequireDefault(_headerNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuComponent = function (_React$Component) {
	  _inherits(MenuComponent, _React$Component);
	
	  function MenuComponent() {
	    _classCallCheck(this, MenuComponent);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  MenuComponent.prototype.tellMe = function tellMe() {
	    alert('me');
	  };
	
	  MenuComponent.prototype.showSettings = function showSettings(event) {
	    event.preventDefault();
	  };
	
	  MenuComponent.prototype.render = function render() {
	    return Glamor.createElement(
	      _slide2.default,
	      { isOpen: false, pageWrapId: "page-wrap", outerContainerId: "outer-container" },
	      Glamor.createElement(_headerNav2.default, { 'class': 'burger-nav', onClick: this.tellMe })
	    );
	  };
	
	  return MenuComponent;
	}(_react2.default.Component);
	
	exports.default = MenuComponent;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/header-nav.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _scrollLink = __webpack_require__("./src/components/scroll-link.js");
	
	var _scrollLink2 = _interopRequireDefault(_scrollLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListLink = function ListLink(props) {
	    return Glamor.createElement(
	        'li',
	        null,
	        Glamor.createElement(
	            _gatsbyLink2.default,
	            { className: 'c-btn--link', to: props.to },
	            props.children
	        )
	    );
	};
	// import Scrollchor from 'react-scrollchor';
	
	
	var HeaderNav = function HeaderNav(props) {
	    return Glamor.createElement(
	        'div',
	        null,
	        Glamor.createElement(
	            'ul',
	            { className: props.class },
	            Glamor.createElement(
	                _scrollLink2.default,
	                { to: '#intro', animate: { offset: -120 } },
	                'intro'
	            ),
	            Glamor.createElement(
	                _scrollLink2.default,
	                { to: '#call', animate: { offset: -120 } },
	                'call for abstract'
	            ),
	            Glamor.createElement(
	                _scrollLink2.default,
	                { to: '#register', animate: { offset: -120 } },
	                'register'
	            ),
	            Glamor.createElement(
	                _scrollLink2.default,
	                { to: '#location', animate: { offset: -120 } },
	                'location'
	            ),
	            Glamor.createElement(
	                _scrollLink2.default,
	                { to: '#directions', animate: { offset: -120 } },
	                'directions'
	            )
	        ),
	        Glamor.createElement(
	            'ul',
	            { className: props.class },
	            Glamor.createElement(
	                _scrollLink2.default,
	                { to: '#venue', animate: { offset: -120 } },
	                'venue'
	            ),
	            Glamor.createElement(
	                _scrollLink2.default,
	                { to: '#services', animate: { offset: -120 } },
	                'services'
	            ),
	            Glamor.createElement(
	                _scrollLink2.default,
	                { to: '#tour', animate: { offset: -120 } },
	                'tour'
	            ),
	            Glamor.createElement(
	                _scrollLink2.default,
	                { to: '#contact', animate: { offset: -120 } },
	                'contact us'
	            ),
	            Glamor.createElement(
	                _scrollLink2.default,
	                { to: '#team', animate: { offset: -120 } },
	                'organisers'
	            ),
	            Glamor.createElement(
	                'li',
	                null,
	                Glamor.createElement(
	                    'a',
	                    { className: 'c-btn--link', href: 'https://www.facebook.com/pzaf2018/', target: '_blank' },
	                    'facebook'
	                )
	            )
	        )
	    );
	};
	
	exports.default = HeaderNav;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/headers/home-header.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _burgerMenu = __webpack_require__("./src/components/burger-menu.js");
	
	var _burgerMenu2 = _interopRequireDefault(_burgerMenu);
	
	var _logo = __webpack_require__("./src/components/logo.js");
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _headerNav = __webpack_require__("./src/components/header-nav.js");
	
	var _headerNav2 = _interopRequireDefault(_headerNav);
	
	__webpack_require__("./node_modules/react-sticky-header/styles.css");
	
	var _reactStickyHeader = __webpack_require__("./node_modules/react-sticky-header/index.js");
	
	var _reactStickyHeader2 = _interopRequireDefault(_reactStickyHeader);
	
	var _reactScrollchor = __webpack_require__("./node_modules/react-scrollchor/lib/scrollchor.js");
	
	var _reactScrollchor2 = _interopRequireDefault(_reactScrollchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SmallHeader = function SmallHeader() {
	  return Glamor.createElement(
	    'div',
	    { className: 'header--sticky' },
	    Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(
	        _reactScrollchor2.default,
	        { to: '#home', className: 'header-logo' },
	        Glamor.createElement(_logo2.default, { 'class': 'logo--sm' })
	      ),
	      Glamor.createElement(_headerNav2.default, { 'class': 'header-nav' })
	    )
	  );
	};
	
	var Header = function Header() {
	  return Glamor.createElement(
	    'div',
	    { className: 'header--basic', id: 'home' },
	    Glamor.createElement(_headerNav2.default, { 'class': 'header-nav' })
	  );
	};
	
	var HomeHeader = function HomeHeader() {
	  return Glamor.createElement(
	    _reactStickyHeader2.default
	    // This is the sticky part of the header.
	    ,
	    { header: Glamor.createElement(SmallHeader, null)
	    },
	    Glamor.createElement(
	      'section',
	      { style: { zIndex: '50' } },
	      Glamor.createElement(Header, null)
	    )
	  );
	};
	
	exports.default = HomeHeader;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/logo.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo = __webpack_require__("./src/assets/images/logo.png");
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// console.log('This' + logo);
	// import './index.css'
	
	var LogoComponent = function LogoComponent(props) {
	    return Glamor.createElement('img', { className: props.class, src: _logo2.default, alt: 'Logo' });
	};
	
	exports.default = LogoComponent;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/scroll-link.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactScrollchor = __webpack_require__("./node_modules/react-scrollchor/lib/scrollchor.js");
	
	var _reactScrollchor2 = _interopRequireDefault(_reactScrollchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScrollLink = function ScrollLink(props) {
	    return Glamor.createElement(
	        'li',
	        null,
	        Glamor.createElement(
	            _reactScrollchor2.default,
	            { className: 'c-btn--link', to: props.to, animate: props.animate },
	            props.children
	        )
	    );
	};
	
	exports.default = ScrollLink;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/section-call.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__("./src/components/image.js");
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionCallComponent = function SectionCallComponent(props) {
	    return Glamor.createElement(
	        'div',
	        { className: 'section--secondary', id: 'call' },
	        Glamor.createElement(
	            'div',
	            { className: 'section__grid' },
	            Glamor.createElement(
	                'div',
	                { className: 'section__text' },
	                Glamor.createElement(
	                    'h2',
	                    null,
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        'Extended Call for Abstracts!'
	                    )
	                ),
	                Glamor.createElement(
	                    'p',
	                    null,
	                    'If you are considering submitting a proposal related to zooarchaeology, now is the time.',
	                    Glamor.createElement('br', null),
	                    'We accept proposals for papers and posters on any topic related to zooarchaeology.'
	                ),
	                Glamor.createElement(
	                    'p',
	                    null,
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        'The program will be announced once the abstracts have been selected'
	                    )
	                ),
	                Glamor.createElement(
	                    'p',
	                    null,
	                    'The ',
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        'deadline'
	                    ),
	                    ' for sending an abstract is extended until the ',
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        '15',
	                        Glamor.createElement(
	                            'sup',
	                            null,
	                            'st'
	                        ),
	                        ' April 2018'
	                    )
	                )
	            ),
	            Glamor.createElement(
	                'div',
	                { className: 'section__text u-text-center' },
	                Glamor.createElement(
	                    'p',
	                    { className: 'c-grid--thirds' },
	                    Glamor.createElement(_image2.default, { image: 'txt' }),
	                    Glamor.createElement(_image2.default, { image: 'pdf' }),
	                    Glamor.createElement(_image2.default, { image: 'word' })
	                ),
	                Glamor.createElement(
	                    'p',
	                    null,
	                    Glamor.createElement(
	                        'a',
	                        { className: 'c-btn--secondary-alt', href: 'https://goo.gl/forms/OQOVBuOh1XWDXeuq2', target: '_blank' },
	                        'Send your abstract'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = SectionCallComponent;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/section-contact.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__("./src/components/image.js");
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionContactComponent = function (_React$Component) {
	    _inherits(SectionContactComponent, _React$Component);
	
	    function SectionContactComponent() {
	        _classCallCheck(this, SectionContactComponent);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    SectionContactComponent.prototype.render = function render() {
	        return Glamor.createElement(
	            'div',
	            { className: 'section--fourth', id: 'contact' },
	            Glamor.createElement(
	                'div',
	                { className: 'section__grid' },
	                Glamor.createElement(
	                    'div',
	                    { className: 'section__text' },
	                    Glamor.createElement(
	                        'h2',
	                        null,
	                        'Contact us'
	                    ),
	                    Glamor.createElement(
	                        'p',
	                        null,
	                        'Please, contact us if you have any questions.',
	                        Glamor.createElement('br', null),
	                        'We will be more than happy to answer.'
	                    )
	                ),
	                Glamor.createElement(
	                    'div',
	                    { className: 'section__text u-text-center' },
	                    Glamor.createElement(
	                        'form',
	                        { className: 'section-form', name: 'contact', method: 'post', 'data-netlify-honeypot': 'bot-field', action: '/thank-you-contact/', 'data-netlify': 'true' },
	                        Glamor.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact' }),
	                        Glamor.createElement(
	                            'p',
	                            { className: 'u-hidden' },
	                            Glamor.createElement(
	                                'label',
	                                { className: 'hidden' },
	                                'Don\u2019t fill this out: ',
	                                Glamor.createElement('input', { name: 'bot-field' })
	                            )
	                        ),
	                        Glamor.createElement('textarea', { placeholder: 'message', name: 'message', required: true }),
	                        Glamor.createElement('input', { type: 'email', placeholder: 'email', name: 'email', required: true }),
	                        Glamor.createElement('div', { 'data-netlify-recaptcha': true }),
	                        Glamor.createElement(
	                            'button',
	                            { type: 'submit', className: 'c-btn--fourth' },
	                            'Send'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return SectionContactComponent;
	}(_react2.default.Component);
	
	exports.default = SectionContactComponent;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/section-profiles.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__("./src/components/image.js");
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionProfilesComponent = function SectionProfilesComponent(props) {
	    return Glamor.createElement(
	        'div',
	        { className: 'section--primary', id: 'team' },
	        Glamor.createElement(
	            'div',
	            { className: 'section__grid' },
	            Glamor.createElement(
	                'div',
	                { className: 'section__img u-text-center' },
	                Glamor.createElement(_image2.default, { image: 'sheep' })
	            ),
	            Glamor.createElement(
	                'div',
	                { className: 'section__text' },
	                Glamor.createElement(
	                    'h2',
	                    null,
	                    'Organisers'
	                ),
	                Glamor.createElement(
	                    'div',
	                    null,
	                    Glamor.createElement(
	                        'p',
	                        null,
	                        Glamor.createElement(
	                            'strong',
	                            null,
	                            'Veronica Aniceti'
	                        ),
	                        Glamor.createElement('br', null),
	                        Glamor.createElement(
	                            'small',
	                            null,
	                            'PhD student in Zooarchaeology at the University of Sheffield (UK).',
	                            Glamor.createElement('br', null),
	                            'Her research project is focused on animal husbandry in Sicily during the medieval period (7',
	                            Glamor.createElement(
	                                'sup',
	                                null,
	                                'th'
	                            ),
	                            ' \u2013 13',
	                            Glamor.createElement(
	                                'sup',
	                                null,
	                                'th'
	                            ),
	                            ' centuries AD).'
	                        )
	                    )
	                ),
	                Glamor.createElement(
	                    'div',
	                    null,
	                    Glamor.createElement(
	                        'p',
	                        null,
	                        Glamor.createElement(
	                            'strong',
	                            null,
	                            'Matteo Bormetti'
	                        ),
	                        Glamor.createElement('br', null),
	                        Glamor.createElement(
	                            'small',
	                            null,
	                            'MSc Osteoarchaelogy at the University of Sheffield (UK).',
	                            Glamor.createElement('br', null),
	                            'His research focuses on animal husbandry and waste disposal practices in Italy and Britain during the Iron Age.'
	                        )
	                    )
	                ),
	                Glamor.createElement(
	                    'div',
	                    null,
	                    Glamor.createElement(
	                        'p',
	                        null,
	                        Glamor.createElement(
	                            'strong',
	                            null,
	                            'Mauro Rizzetto'
	                        ),
	                        Glamor.createElement('br', null),
	                        Glamor.createElement(
	                            'small',
	                            null,
	                            'PhD student at the University of Sheffield (UK).',
	                            Glamor.createElement('br', null),
	                            'His research deals with the development of animal husbandry during the late Roman - early medieval transition in Britain and in the lower Rhineland, with particular regard to biometrical changes.'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = SectionProfilesComponent;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/section-program.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__("./src/components/image.js");
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionProgramComponent = function SectionProgramComponent(props) {
	    return Glamor.createElement(
	        'div',
	        { className: 'section--primary', id: 'register' },
	        Glamor.createElement(
	            'div',
	            { className: 'section__grid' },
	            Glamor.createElement(
	                'div',
	                { className: 'section__text' },
	                Glamor.createElement(
	                    'h2',
	                    null,
	                    'Program'
	                ),
	                Glamor.createElement(
	                    'p',
	                    null,
	                    'The program will be defined and uploaded once the abstracts will be selected'
	                )
	            ),
	            Glamor.createElement(
	                'div',
	                { className: 'section__text u-text-center' },
	                Glamor.createElement(
	                    'div',
	                    { className: 'u-text-center' },
	                    Glamor.createElement(
	                        'p',
	                        { className: 'c-grid--thirds' },
	                        Glamor.createElement(_image2.default, { 'class': 'c-column-offset', image: 'pdf-inverted' })
	                    ),
	                    Glamor.createElement(
	                        'p',
	                        null,
	                        Glamor.createElement(
	                            'span',
	                            { className: 'c-btn--fourth', href: '#', target: '_blank' },
	                            'Coming soon'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = SectionProgramComponent;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/section-register.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__("./src/components/image.js");
	
	var _image2 = _interopRequireDefault(_image);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionRegisterComponent = function (_React$Component) {
	    _inherits(SectionRegisterComponent, _React$Component);
	
	    function SectionRegisterComponent(props) {
	        _classCallCheck(this, SectionRegisterComponent);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	        _this.state = props;
	        return _this;
	    }
	
	    SectionRegisterComponent.prototype.loadRegister = function loadRegister() {
	        typeof window !== 'undefined' && (window.location.href = '/register/');
	    };
	
	    SectionRegisterComponent.prototype.render = function render() {
	        return Glamor.createElement(
	            'div',
	            { className: 'section--fourth', id: 'register' },
	            Glamor.createElement(
	                'div',
	                { className: 'section__grid' },
	                Glamor.createElement(
	                    'div',
	                    { className: 'section__text' },
	                    Glamor.createElement(
	                        'h2',
	                        null,
	                        'Register'
	                    ),
	                    Glamor.createElement(
	                        'p',
	                        null,
	                        'Register now for the event (limited tickets are available).',
	                        Glamor.createElement('br', null),
	                        'The ticket will include the conference material, lunches and coffee breaks.'
	                    ),
	                    Glamor.createElement(
	                        'p',
	                        null,
	                        'If you are funded/waged for your studies/job, or if you received a grant for participating to this conference: ',
	                        Glamor.createElement(
	                            'strong',
	                            null,
	                            '25\u20AC'
	                        ),
	                        Glamor.createElement('br', null),
	                        'If you are unfunded/unwaged and did not receive any grant: ',
	                        Glamor.createElement(
	                            'strong',
	                            null,
	                            '20\u20AC'
	                        )
	                    )
	                ),
	                Glamor.createElement(
	                    'div',
	                    { className: 'section__text u-text-center' },
	                    Glamor.createElement(
	                        'div',
	                        { className: 'u-text-center' },
	                        Glamor.createElement(
	                            'p',
	                            { className: 'c-grid--thirds' },
	                            Glamor.createElement(_image2.default, { 'class': 'c-column-offset', image: 'stylus' })
	                        ),
	                        Glamor.createElement(
	                            'p',
	                            null,
	                            Glamor.createElement(
	                                'button',
	                                { className: 'c-btn--fourth', onClick: this.loadRegister },
	                                'Register now'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return SectionRegisterComponent;
	}(_react2.default.Component);
	
	exports.default = SectionRegisterComponent;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/section-services.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__("./src/components/image.js");
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionServicesComponent = function SectionServicesComponent(props) {
	    return Glamor.createElement(
	        'div',
	        { className: 'section--fourth' },
	        Glamor.createElement(
	            'div',
	            { className: 'section__grid', id: 'services' },
	            Glamor.createElement(
	                'div',
	                { className: 'section__text' },
	                Glamor.createElement(
	                    'h2',
	                    null,
	                    'Services '
	                ),
	                Glamor.createElement(
	                    'p',
	                    { className: 'section__subtitle' },
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        'Lunches'
	                    )
	                ),
	                Glamor.createElement(
	                    'p',
	                    null,
	                    'The ',
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        'PZAF'
	                    ),
	                    ' conference lunches (included in the registration fee) are going to take place on the ',
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        '27',
	                        Glamor.createElement(
	                            'sup',
	                            null,
	                            'th'
	                        )
	                    ),
	                    ' and on the ',
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        '28',
	                        Glamor.createElement(
	                            'sup',
	                            null,
	                            'th'
	                        )
	                    ),
	                    ' of June 2018 at ',
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        'Osteria Ballar\xF2'
	                    ),
	                    '.',
	                    Glamor.createElement('br', null),
	                    'If you have any allergies to specific food products, please specify them on the PZAF Registration. Vegetarian and vegan options will be available.'
	                ),
	                Glamor.createElement(
	                    'div',
	                    null,
	                    Glamor.createElement(
	                        'p',
	                        { className: 'section__subtitle' },
	                        Glamor.createElement(
	                            'strong',
	                            null,
	                            'Accomodations'
	                        )
	                    ),
	                    Glamor.createElement(
	                        'p',
	                        null,
	                        'We established a special agreement for student accomodations (',
	                        Glamor.createElement(
	                            'strong',
	                            null,
	                            'NOT'
	                        ),
	                        ' included in the registration fees) with ',
	                        Glamor.createElement(
	                            'strong',
	                            null,
	                            'Hotel Concordia'
	                        ),
	                        ', which is located on the fourth floor of an elegant building near the venue of the conference.',
	                        Glamor.createElement('br', null),
	                        Glamor.createElement(
	                            'a',
	                            { className: 'c-btn--link', href: 'https://drive.google.com/open?id=1S1J5J2xnqNc-hp3YICour1CteoZgtDc2', target: '_blank' },
	                            'Download the pdf with room prices and booking info.'
	                        )
	                    )
	                )
	            ),
	            Glamor.createElement(
	                'div',
	                { className: 'section__text' },
	                Glamor.createElement(
	                    'div',
	                    { className: 'cards' },
	                    Glamor.createElement(
	                        'div',
	                        { className: 'card' },
	                        Glamor.createElement(
	                            'div',
	                            { className: 'logo' },
	                            Glamor.createElement(_image2.default, { image: 'osteria' })
	                        ),
	                        Glamor.createElement(
	                            'div',
	                            { className: 'info' },
	                            Glamor.createElement(
	                                'p',
	                                null,
	                                'Osteria Ballar\xF2',
	                                Glamor.createElement('br', null),
	                                Glamor.createElement(
	                                    'em',
	                                    null,
	                                    'Put\xECa del Gusto Siciliano'
	                                )
	                            ),
	                            Glamor.createElement(
	                                'a',
	                                { className: 'site', href: 'http://osteriaballaro.it', target: '_blank' },
	                                'osteriaballaro.it'
	                            ),
	                            Glamor.createElement(
	                                'a',
	                                { className: 'location', href: 'https://goo.gl/maps/6AUdnvcB9AR2', target: '_blank' },
	                                'see on map'
	                            )
	                        )
	                    ),
	                    Glamor.createElement(
	                        'div',
	                        { className: 'card' },
	                        Glamor.createElement(
	                            'div',
	                            { className: 'logo' },
	                            Glamor.createElement(_image2.default, { image: 'concordia' })
	                        ),
	                        Glamor.createElement(
	                            'div',
	                            { className: 'info' },
	                            Glamor.createElement(
	                                'p',
	                                null,
	                                'Hotel Concordia',
	                                Glamor.createElement('br', null),
	                                Glamor.createElement(
	                                    'a',
	                                    { href: 'https://drive.google.com/open?id=1S1J5J2xnqNc-hp3YICour1CteoZgtDc2' },
	                                    Glamor.createElement(
	                                        'em',
	                                        null,
	                                        'Room prices and booking info'
	                                    )
	                                )
	                            ),
	                            Glamor.createElement(
	                                'a',
	                                { className: 'site', href: 'http://www.hotelconcordiapalermo.it/en-us/', target: '_blank' },
	                                'hotelconcordiapalermo.it'
	                            ),
	                            Glamor.createElement(
	                                'a',
	                                { className: 'location', href: 'https://goo.gl/maps/Pvq7rQvw9iN2', target: '_blank' },
	                                'see on map'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = SectionServicesComponent;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/section-sponsor.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__("./src/components/image.js");
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionSponsorComponent = function SectionSponsorComponent(props) {
	    return Glamor.createElement(
	        'div',
	        { className: 'section--secondary u-text-center', id: 'sponsor' },
	        Glamor.createElement(
	            'small',
	            null,
	            'Sponsored by'
	        ),
	        Glamor.createElement(
	            'div',
	            { className: 'c-grid--sponsors' },
	            Glamor.createElement(
	                'a',
	                { href: 'http://www.regione.sicilia.it/beniculturali/sopripa/', target: '_blank', alt: 'Soprintendenza di Palermo' },
	                Glamor.createElement(_image2.default, { image: 'sop' })
	            ),
	            Glamor.createElement(
	                'a',
	                { href: 'https://www.sheffield.ac.uk', target: '_blank', alt: 'University of Sheffield' },
	                Glamor.createElement(_image2.default, { image: 'sheff' })
	            ),
	            Glamor.createElement(
	                'a',
	                { href: 'https://ludwig.guru', target: '_blank', alt: 'Ludwig' },
	                Glamor.createElement(_image2.default, { image: 'lud' })
	            ),
	            Glamor.createElement(
	                'a',
	                { href: 'https://www.alexandriaarchive.org/icaz/', target: '_blank', alt: 'Icaz - International Council for Archaeology' },
	                Glamor.createElement(_image2.default, { image: 'icaz' })
	            ),
	            Glamor.createElement(
	                'a',
	                { href: 'http://www.aiaz.it/', target: '_blank', alt: 'Aiaz - Associazione Italiana Archeologia' },
	                Glamor.createElement(_image2.default, { image: 'aiaz' })
	            ),
	            Glamor.createElement(
	                'a',
	                { href: 'https://www.barpublishing.com/', target: '_blank', alt: 'BAR - Publishing' },
	                Glamor.createElement(_image2.default, { image: 'bar' })
	            ),
	            Glamor.createElement(
	                'a',
	                { href: 'https://www.oxbowbooks.com/', target: '_blank', alt: 'Oxbooks' },
	                Glamor.createElement(_image2.default, { image: 'ox' })
	            )
	        )
	    );
	};
	
	exports.default = SectionSponsorComponent;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/section-tour.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__("./src/components/image.js");
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionTourComponent = function SectionTourComponent(props) {
	    return Glamor.createElement(
	        'div',
	        { className: 'section--primary' },
	        Glamor.createElement(
	            'div',
	            { className: 'section__grid', id: 'tour' },
	            Glamor.createElement(
	                'div',
	                { className: 'section__img u-text-center' },
	                Glamor.createElement(_image2.default, { image: 'tour' })
	            ),
	            Glamor.createElement(
	                'div',
	                { className: 'section__text' },
	                Glamor.createElement(
	                    'h2',
	                    null,
	                    'Tour'
	                ),
	                Glamor.createElement(
	                    'p',
	                    { className: 'section__subtitle' },
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        'Informal evening tours and one-day excursion'
	                    )
	                ),
	                Glamor.createElement(
	                    'p',
	                    null,
	                    'Since 2015, the Arab and Norman buildings and infrastructures of Palermo, Cefal\xF9 and Monreale have been ',
	                    Glamor.createElement(
	                        'a',
	                        { href: 'http://whc.unesco.org/en/list/1487', target: '_blank', className: 'section__link' },
	                        'UNESCO World Heritage sites'
	                    ),
	                    '.',
	                    Glamor.createElement('br', null),
	                    'The important Arab and Norman sites scattered throughout ',
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        'Palermo'
	                    ),
	                    ' represent major attractions and they will be part of informal evening tours.'
	                ),
	                Glamor.createElement(
	                    'div',
	                    null,
	                    'The evening tours could include visits to:',
	                    Glamor.createElement(
	                        'ul',
	                        { className: 'section__list' },
	                        Glamor.createElement(
	                            'li',
	                            null,
	                            'Palermo Royal Palace and Palatine Chapel'
	                        ),
	                        Glamor.createElement(
	                            'li',
	                            null,
	                            'Palermo Cathedral'
	                        ),
	                        Glamor.createElement(
	                            'li',
	                            null,
	                            'Church of San Giovanni degli Eremiti'
	                        ),
	                        Glamor.createElement(
	                            'li',
	                            null,
	                            'Church of Santa Maria dell\u2019Ammiraglio'
	                        ),
	                        Glamor.createElement(
	                            'li',
	                            null,
	                            'Church of San Cataldo'
	                        ),
	                        Glamor.createElement(
	                            'li',
	                            null,
	                            'Church of Magione'
	                        )
	                    )
	                ),
	                Glamor.createElement(
	                    'p',
	                    null,
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        'The Cathedral and town of Cefal\xF9 (and its beach!)'
	                    ),
	                    ' have been chosen for the ',
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        'one-day excursion'
	                    ),
	                    ', which will take place on ',
	                    Glamor.createElement(
	                        'strong',
	                        null,
	                        '29',
	                        Glamor.createElement(
	                            'sup',
	                            null,
	                            'th'
	                        ),
	                        ' of June 2018'
	                    ),
	                    '.'
	                ),
	                Glamor.createElement(
	                    'p',
	                    null,
	                    'On the registration form you will be asked if you are interested in the one-day excursion'
	                )
	            )
	        )
	    );
	};
	
	exports.default = SectionTourComponent;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/section.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _image = __webpack_require__("./src/components/image.js");
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionComponent = function SectionComponent(props) {
	    return Glamor.createElement(
	        'div',
	        { className: props.section.frontmatter.class, id: props.section.frontmatter.hash },
	        Glamor.createElement(
	            'div',
	            { className: 'section__grid' },
	            Glamor.createElement(
	                'div',
	                { className: 'section__img' },
	                Glamor.createElement(_image2.default, { image: props.section.frontmatter.image })
	            ),
	            Glamor.createElement('div', { className: 'section__text', dangerouslySetInnerHTML: { __html: props.section.html } })
	        )
	    );
	};
	
	exports.default = SectionComponent;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.IndexQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _homeHeader = __webpack_require__("./src/components/headers/home-header.js");
	
	var _homeHeader2 = _interopRequireDefault(_homeHeader);
	
	var _section = __webpack_require__("./src/components/section.js");
	
	var _section2 = _interopRequireDefault(_section);
	
	var _sectionCall = __webpack_require__("./src/components/section-call.js");
	
	var _sectionCall2 = _interopRequireDefault(_sectionCall);
	
	var _sectionRegister = __webpack_require__("./src/components/section-register.js");
	
	var _sectionRegister2 = _interopRequireDefault(_sectionRegister);
	
	var _sectionProgram = __webpack_require__("./src/components/section-program.js");
	
	var _sectionProgram2 = _interopRequireDefault(_sectionProgram);
	
	var _sectionServices = __webpack_require__("./src/components/section-services.js");
	
	var _sectionServices2 = _interopRequireDefault(_sectionServices);
	
	var _sectionTour = __webpack_require__("./src/components/section-tour.js");
	
	var _sectionTour2 = _interopRequireDefault(_sectionTour);
	
	var _sectionProfiles = __webpack_require__("./src/components/section-profiles.js");
	
	var _sectionProfiles2 = _interopRequireDefault(_sectionProfiles);
	
	var _sectionContact = __webpack_require__("./src/components/section-contact.js");
	
	var _sectionContact2 = _interopRequireDefault(_sectionContact);
	
	var _sectionSponsor = __webpack_require__("./src/components/section-sponsor.js");
	
	var _sectionSponsor2 = _interopRequireDefault(_sectionSponsor);
	
	var _burgerMenu = __webpack_require__("./src/components/burger-menu.js");
	
	var _burgerMenu2 = _interopRequireDefault(_burgerMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var sections = this.props.data.allMarkdownRemark.edges;
	    // const { sections } = this.props.data.allMarkdownRemark.edges;
	    return Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(_homeHeader2.default, null),
	      Glamor.createElement(
	        'div',
	        { className: 'sections' },
	        sections.filter(function (section) {
	          return section.node.frontmatter.title.length > 0 && section.node.frontmatter.id === '1';
	        }).map(function (_ref) {
	          var section = _ref.node;
	
	          return Glamor.createElement(_section2.default, { section: section, key: section.frontmatter.id });
	        }),
	        Glamor.createElement(_sectionCall2.default, null),
	        Glamor.createElement(_sectionRegister2.default, null),
	        Glamor.createElement(_sectionProgram2.default, null),
	        sections.filter(function (section) {
	          return section.node.frontmatter.title.length > 0 && section.node.frontmatter.type === 'section' && section.node.frontmatter.id !== '1';
	        }).map(function (_ref2) {
	          var section = _ref2.node;
	
	          return Glamor.createElement(_section2.default, { section: section, key: section.frontmatter.id });
	        }),
	        Glamor.createElement(_sectionServices2.default, null),
	        Glamor.createElement(_sectionTour2.default, null),
	        Glamor.createElement(_sectionContact2.default, null),
	        Glamor.createElement(_sectionProfiles2.default, null),
	        Glamor.createElement(_sectionSponsor2.default, null)
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	var IndexQuery = exports.IndexQuery = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a7713140c978573f69c6.js